import React from 'react';

import Button from '../Button/Button';

import MarkdownContent from '../MarkdownContent';
import { ReactComponent as SVGbarchart } from '../../assets/svg/bar-chart.svg';

export default function LMS(props) {
	const { blocks } = props;

	return (
		<section className="section-block lms">
			<div className="container">
				<header>
					<h1>{blocks.lms.frontmatter.title}</h1>
				</header>
				<div className="row">
					<div className="col-xs-12 col-md-8">
						<div>
							<MarkdownContent>{blocks.lms.body}</MarkdownContent>
						</div>
					</div>
					<div className="col-xs-12 col-md-4">
						<figure>
							<SVGbarchart />
						</figure>
					</div>
					<div className="clearfix"></div>
					<div className="col-xs-12 outro">
						<p>
							<Button
								href={blocks.lms_outro.frontmatter.linkURL}
								className="btn-primary btn-lg"
								sfx="rising-pops"
							>
								{blocks.lms_outro.frontmatter.linkTitle}
							</Button>
						</p>
					</div>
				</div>
			</div>
		</section>
	);
}
